import BaseComponent from "../BaseComponent";
import HorizontalLayout from "../layouts/HorizontalLayout";
import {ChevronRight} from "react-feather";
import React from "react";
import Stepper from "@mui/material/Stepper";
import PropTypes from "prop-types";

class BreadCrumbBox extends BaseComponent {

  render() {
    return <Stepper activeStep={this.props.activeStep}>
      {this.props.children}
    </Stepper>

  }
}

BreadCrumbBox.propTypes = {
  activeStep: PropTypes.number.isRequired,
}

export default BreadCrumbBox;
